import { mediums } from "./enums";
import { camelCaseToWords } from "./stringHelpers";

const MEDIUM_SPECIFIC_VERBS_FOR_ENGAGED = {
  [mediums.FILM]: "Watched",
  [mediums.TV_SHOW]: "Watched",
  [mediums.BOOK]: "Read",
  [mediums.ALBUM]: "Listened to",
  [mediums.PODCAST]: "Listened to",
};

const MEDIUMS_SPECIFIC_WORD_FOR_ENTRY = {
  [mediums.ALBUM]: {
    singular: "Track",
    plural: "Tracks",
  },
  [mediums.PODCAST]: {
    singular: "Episode",
    plural: "Episodes",
  },
};

export function mediumIsValid(medium) {
  return Object.values(mediums).includes(medium);
}

export function assertMediumIsValid(medium) {
  if (!mediumIsValid(medium)) {
    throw new Error("Invalid medium");
  }
}

export function userFriendlyMediumWord(medium, plural = false) {
  assertMediumIsValid(medium);
  let word = camelCaseToWords(medium);
  if (word.startsWith("Tv")) {
    word = "TV" + word.substring(2);
  }
  if (plural) {
    word = word + "s";
  }
  return word;
}

export function mediumSpecificVerbForEngaged(medium) {
  assertMediumIsValid(medium);
  return MEDIUM_SPECIFIC_VERBS_FOR_ENGAGED[medium];
}

export function mediumSpecificWordForEntry(medium, plural = false) {
  assertMediumIsValid(medium);
  const mediumWords = MEDIUMS_SPECIFIC_WORD_FOR_ENTRY[medium];
  return plural ? mediumWords.plural : mediumWords.singular;
}

export function mediumSpecificWordForCreator(medium, plural = false) {
  const creatorWords = {
    [this.$mediums.FILM]: {
      plural: "Directors",
      singular: "Director",
    },
    [this.$mediums.BOOK]: {
      plural: "Authors",
      singular: "Author",
    },
    [this.$mediums.ALBUM]: {
      plural: "Artists",
      singular: "Artist",
    },
    [this.$mediums.PODCAST]: {
      plural: "Publishers",
      singular: "Publisher",
    },
  };
  const wordSet = creatorWords[medium] || {
    plural: "Creators",
    singular: "Creator",
  };
  return plural ? wordSet.plural : wordSet.singular;
}

export function getSubtitleFromWork(work) {
  if (work.mediun === mediums.FILM) {
    return work.releaseDate ? work.releaseDate.substring(0, 4) : undefined;
  } else {
    return work.creators.map((creator) => creator.name).join(", ");
  }
}
